
{
  "familyId": "REK-CONTEXT-PLUS-MIN",
  "questions": [
    {
      "id": "REK-CONTEXT-PLUS-MIN-001",
      "familyId": "REK-CONTEXT-PLUS-MIN",
      "module": "Basisrekenen",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "context",
      "subSkill": "context_optellen_aftrekken",
      "questionType": "multiple_choice",
      "question": "Je spaart voor een skateboard van €89. Je hebt al €47 gespaard. Je oma geeft je €25 voor je verjaardag. Hoeveel moet je nog sparen?",
      "options": ["€17", "€42", "€72", "€64"],
      "correctAnswer": 0,
      "conceptId": "context_plus_min_sparen_skateboard",
      "variantIndex": 1,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.78,
      "context": "Sparen voor skateboard",
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Eerst optellen, dan aftrekken",
            "content": "Stap 1: Hoeveel heb je nu? €47 + €25 = €72. Stap 2: Hoeveel moet je nog? €89 − €72 = €17. Tip: lees goed wat de vraag is — 'hoeveel moet je NOG sparen'.",
            "icon": "lightbulb"
          }
        }
      ],
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "rek.context-step-forgotten", "label": "Vergeet oma's cadeau op te tellen", "optionIndex": 1 },
          { "id": "rek.partial-calculation", "label": "Berekent alleen het totaal gespaarde", "optionIndex": 2 },
          { "id": "rek.context-direction-wrong", "label": "Trekt verkeerd bedrag af", "optionIndex": 3 }
        ]
      },
      "feedback": {
        "explanationText": "Stap 1: Je hebt nu €47 + €25 (van oma) = €72. Stap 2: Het skateboard kost €89. Je moet nog €89 − €72 = €17 sparen. Lees goed: de vraag is hoeveel je NOG moet sparen.",
        "solutionSteps": [
          "Stap 1: Totaal gespaard — €47 + €25 = €72",
          "Stap 2: Nog nodig — €89 − €72 = €17",
          "Check: €72 + €17 = €89 ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! €47 + €25 = €72 gespaard. €89 − €72 = €17 nog nodig.",
          "1": "Je vergat het cadeau van oma! Je hebt niet alleen €47, maar €47 + €25 = €72. Dan: €89 − €72 = €17.",
          "2": "Je berekende hoeveel je hebt (€72), maar de vraag is hoeveel je NOG moet sparen. €89 − €72 = €17.",
          "3": "Je dacht waarschijnlijk €89 − €25 = €64. Maar je moet eerst je spaargeld en het cadeau optellen: €47 + €25 = €72. Dan: €89 − €72 = €17."
        }
      }
    },
    {
      "id": "REK-CONTEXT-PLUS-MIN-002",
      "familyId": "REK-CONTEXT-PLUS-MIN",
      "module": "Basisrekenen",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "context",
      "subSkill": "context_optellen_aftrekken",
      "questionType": "multiple_choice",
      "question": "Een magazijnmedewerker telt de voorraad. 's Ochtends zijn er 1.250 dozen. Er worden 387 dozen uitgeleverd en later komen er 145 dozen bij. Hoeveel dozen zijn er aan het eind van de dag?",
      "options": ["1.008 dozen", "1.782 dozen", "863 dozen", "1.108 dozen"],
      "correctAnswer": 0,
      "conceptId": "context_plus_min_voorraad",
      "variantIndex": 2,
      "citoDifficulty": 0.44,
      "citoDiscrimination": 0.80,
      "context": "Magazijn voorraad",
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Lees de richting: erbij of eraf?",
            "content": "Uitgeleverd = eraf (−). Bijkomen = erbij (+). Reken: 1.250 − 387 = 863, dan 863 + 145 = 1.008.",
            "icon": "lightbulb"
          }
        }
      ],
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "rek.context-direction-wrong", "label": "Telt alles op i.p.v. uitgeleverd af te trekken", "optionIndex": 1 },
          { "id": "rek.context-step-forgotten", "label": "Vergeet de bijgekomen dozen op te tellen", "optionIndex": 2 },
          { "id": "rek.carry-forgotten", "label": "Rekenfout bij aftrekken of optellen", "optionIndex": 3 }
        ]
      },
      "feedback": {
        "explanationText": "Uitgeleverd = eraf: 1.250 − 387 = 863. Bijkomen = erbij: 863 + 145 = 1.008 dozen. Markeer in de tekst wat erbij komt (+) en wat eraf gaat (−).",
        "solutionSteps": [
          "Stap 1: Begin — 1.250 dozen",
          "Stap 2: Uitgeleverd (−) — 1.250 − 387 = 863",
          "Stap 3: Bijgekomen (+) — 863 + 145 = 1.008",
          "Check: 1.008 dozen ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! 1.250 − 387 + 145 = 1.008 dozen.",
          "1": "Je telde alles op: 1.250 + 387 + 145 = 1.782. Maar 387 dozen werden UITGELEVERD — dat is aftrekken.",
          "2": "Je berekende 1.250 − 387 = 863, maar vergat de 145 dozen die bijkwamen. 863 + 145 = 1.008.",
          "3": "Controleer je berekening: 1.250 − 387 = 863, dan 863 + 145 = 1.008 (niet 1.108)."
        }
      }
    },
    {
      "id": "REK-CONTEXT-PLUS-MIN-003",
      "familyId": "REK-CONTEXT-PLUS-MIN",
      "module": "Basisrekenen",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "context",
      "subSkill": "context_optellen_aftrekken",
      "questionType": "step_solver",
      "question": "Je hebt 500 V-Bucks in Fortnite. Je koopt een skin voor 200 V-Bucks en een emote voor 150 V-Bucks. Daarna win je een wedstrijd en krijgt 75 V-Bucks. Hoeveel V-Bucks heb je nu?",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "steps": [
          { "prompt": "Hoeveel V-Bucks heb je na de skin? (500 − 200)", "correctAnswer": "300", "hint": "500 − 200 = 300 V-Bucks" },
          { "prompt": "Hoeveel na de emote? (300 − 150)", "correctAnswer": "150", "hint": "300 − 150 = 150 V-Bucks" },
          { "prompt": "Hoeveel na de wedstrijd? (150 + 75)", "correctAnswer": "225", "hint": "150 + 75 = 225 V-Bucks" }
        ],
        "finalAnswer": "225"
      },
      "conceptId": "context_plus_min_gaming_vbucks",
      "variantIndex": 3,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.76,
      "context": "Fortnite V-Bucks",
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Stap voor stap: kopen = eraf, winnen = erbij",
            "content": "Begin: 500. Skin kopen (−200): 300. Emote kopen (−150): 150. Wedstrijd winnen (+75): 225 V-Bucks.",
            "icon": "lightbulb"
          }
        }
      ],
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": []
      },
      "feedback": {
        "explanationText": "Werk stap voor stap: 500 − 200 = 300 (skin). 300 − 150 = 150 (emote). 150 + 75 = 225 (wedstrijd gewonnen). Je hebt nu 225 V-Bucks.",
        "solutionSteps": [
          "Stap 1: 500 − 200 = 300 (skin gekocht)",
          "Stap 2: 300 − 150 = 150 (emote gekocht)",
          "Stap 3: 150 + 75 = 225 (wedstrijd gewonnen)",
          "Check: 225 V-Bucks ✓"
        ]
      }
    },
    {
      "id": "REK-CONTEXT-PLUS-MIN-004",
      "familyId": "REK-CONTEXT-PLUS-MIN",
      "module": "Basisrekenen",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "context",
      "subSkill": "context_optellen_aftrekken",
      "questionType": "multiple_choice",
      "question": "Een kassamedewerker telt de kassa op. Er zit €487,50 in de kassa. Vandaag is er €1.235,75 ontvangen en €362,80 wisselgeld teruggegeven. Hoeveel zit er nu in de kassa?",
      "options": ["€1.360,45", "€1.723,25", "€2.086,05", "€1.598,25"],
      "correctAnswer": 0,
      "conceptId": "context_plus_min_geld_kassa",
      "variantIndex": 4,
      "citoDifficulty": 0.50,
      "citoDiscrimination": 0.82,
      "context": "Kassa opmaken",
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Ontvangen = erbij, teruggegeven = eraf",
            "content": "Begin: €487,50. Ontvangen (+): €487,50 + €1.235,75 = €1.723,25. Wisselgeld (−): €1.723,25 − €362,80 = €1.360,45.",
            "icon": "lightbulb"
          }
        }
      ],
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "rek.context-step-forgotten", "label": "Vergeet wisselgeld af te trekken", "optionIndex": 1 },
          { "id": "rek.context-direction-wrong", "label": "Telt alle bedragen op", "optionIndex": 2 },
          { "id": "rek.partial-calculation", "label": "Begint niet bij het startbedrag", "optionIndex": 3 }
        ]
      },
      "feedback": {
        "explanationText": "Begin: €487,50. Ontvangen (+): 487,50 + 1.235,75 = 1.723,25. Wisselgeld terug (−): 1.723,25 − 362,80 = 1.360,45. Er zit nu €1.360,45 in de kassa.",
        "solutionSteps": [
          "Stap 1: Begin — €487,50",
          "Stap 2: Ontvangen (+) — 487,50 + 1.235,75 = 1.723,25",
          "Stap 3: Wisselgeld (−) — 1.723,25 − 362,80 = 1.360,45",
          "Check: €1.360,45 ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! €487,50 + €1.235,75 − €362,80 = €1.360,45.",
          "1": "Je vergat het wisselgeld af te trekken. Er is €362,80 teruggegeven: 1.723,25 − 362,80 = 1.360,45.",
          "2": "Je telde alles op. Maar wisselgeld wordt TERUGGEGEVEN — dat is aftrekken.",
          "3": "Je vergat het startbedrag (€487,50). Begin altijd bij wat er al in de kassa zit."
        }
      }
    },
    {
      "id": "REK-CONTEXT-PLUS-MIN-005",
      "familyId": "REK-CONTEXT-PLUS-MIN",
      "module": "Basisrekenen",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "context",
      "subSkill": "context_optellen_aftrekken",
      "questionType": "comparison_judge",
      "question": "Welke berekening hoort bij welk verhaaltje? Beoordeel of de berekening klopt.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "comparisonJudge": {
          "pairs": [
            {
              "left": "Je hebt 350 volgers op TikTok. Er komen 128 bij en 45 stoppen. Hoeveel heb je nu?",
              "right": "350 + 128 − 45 = 433",
              "isCorrect": true,
              "explanation": "Bijkomen = optellen (+128), stoppen = aftrekken (−45). 350 + 128 − 45 = 433. Klopt!"
            },
            {
              "left": "Een winkel heeft 820 artikelen. Er worden 265 verkocht en 180 nieuwe geleverd.",
              "right": "820 − 265 − 180 = 375",
              "isCorrect": false,
              "explanation": "Verkocht = aftrekken (−265), maar nieuwe geleverd = optellen (+180), niet aftrekken! Het moet zijn: 820 − 265 + 180 = 735."
            },
            {
              "left": "Je hebt €150. Je koopt schoenen van €65 en een shirt van €28.",
              "right": "150 − 65 − 28 = 57",
              "isCorrect": true,
              "explanation": "Kopen = aftrekken. 150 − 65 = 85, dan 85 − 28 = 57. Klopt!"
            }
          ]
        }
      },
      "conceptId": "context_plus_min_judge_richting",
      "variantIndex": 5,
      "citoDifficulty": 0.45,
      "citoDiscrimination": 0.78,
      "context": "Berekening bij verhaaltje",
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Erbij = optellen, eraf = aftrekken",
            "content": "Lees het verhaaltje goed. Woorden als 'bijkomen', 'erbij', 'geleverd' = optellen (+). Woorden als 'verkocht', 'kopen', 'stoppen' = aftrekken (−).",
            "icon": "lightbulb"
          }
        }
      ],
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": []
      },
      "feedback": {
        "explanationText": "Let op signaalwoorden: 'bijkomen/geleverd' = optellen, 'verkocht/kopen/stoppen' = aftrekken. De tweede berekening klopt niet: 'nieuwe geleverd' is optellen, niet aftrekken.",
        "solutionSteps": [
          "Paar 1: bijkomen (+128), stoppen (−45) → 350 + 128 − 45 = 433 ✓",
          "Paar 2: verkocht (−265), geleverd (+180) → moet zijn 820 − 265 + 180 = 735 ✗",
          "Paar 3: kopen (−65), kopen (−28) → 150 − 65 − 28 = 57 ✓"
        ]
      }
    },
    {
      "id": "REK-CONTEXT-PLUS-MIN-006",
      "familyId": "REK-CONTEXT-PLUS-MIN",
      "module": "Basisrekenen",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "context",
      "subSkill": "context_optellen_aftrekken",
      "questionType": "multiple_choice",
      "question": "Een boekhandelaar heeft 3 kasten met boeken. In de eerste kast staan 248 boeken, in de tweede 175 en in de derde 312. Ze verkoopt er 89. Hoeveel boeken heeft ze nog?",
      "options": ["646", "735", "624", "736"],
      "correctAnswer": 0,
      "conceptId": "context_plus_min_meerdere_optellen",
      "variantIndex": 6,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.76,
      "context": "Boekwinkel",
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Eerst optellen, dan aftrekken",
            "content": "Totaal: 248 + 175 + 312 = 735. Verkocht: 735 − 89 = 646.",
            "icon": "lightbulb"
          }
        }
      ],
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "rek.context-step-forgotten", "label": "Vergeet verkochte af te trekken", "optionIndex": 1 },
          { "id": "rek.carry-forgotten", "label": "Rekenfout bij aftrekken", "optionIndex": 2 },
          { "id": "rek.carry-forgotten", "label": "Optelfout bij totaal", "optionIndex": 3 }
        ]
      },
      "feedback": {
        "explanationText": "Totaal: 248 + 175 + 312 = 735 boeken. Verkocht: 735 − 89 = 646 boeken over.",
        "solutionSteps": [
          "Stap 1: 248 + 175 = 423",
          "Stap 2: 423 + 312 = 735 totaal",
          "Stap 3: 735 − 89 = 646 boeken over",
          "Check: 646 + 89 = 735 ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! 248 + 175 + 312 = 735, dan 735 − 89 = 646.",
          "1": "Je berekende het totaal (735) maar vergat de 89 verkochte boeken af te trekken.",
          "2": "Controleer: 735 − 89 = 646, niet 624. Misschien een leenfout bij het aftrekken.",
          "3": "Controleer: 248 + 175 = 423, dan 423 + 312 = 735, niet 736."
        }
      }
    }
  ]
}
